import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { Container } from "../general/GeneralStyles"
import Product from "./Product"

const StyledContainer = styled(Container)`
  display: grid;
  grid-template-columns: 20% auto;
  position: relative;
  padding: 20px 0;
  width: 100%;
  z-index: 10;

  &::after {
    content: "";
    position: absolute;
    bottom: 20px;
    width: 100%;
    height: 2px;
    background: #fff;
  }

  > div:nth-child(3n) {
    border-right: 0px;
  }

  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-template-columns: 1fr 1fr;

    > div:nth-child(3n) {
      border-right: 2px solid #f0efea;
    }

    > div:nth-child(2n) {
      border-right: 0px;
    }
  }

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    /* grid-template-columns: 1fr; */
  }
`

const PageLink = styled.span`
  color: ${props => (props.active ? "black" : props.theme.primaryColor)}!important;
  display: inline-block;
  font-weight: bold;
  padding-right: 5px;
  cursor: pointer;
`

const Pagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 20px;
  grid-column-end: 4;
  grid-column-start: 1;

  span {
    color: ${props => props.theme.secondaryTextColor};
    font-family: ${props => props.theme.primaryFont};
    font-size: 16px;
    line-height: 24px;
  }

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-column-end: 3;
  }
`

const productsPerPage = 9

const producePages = (products, activePage, setActivePage) => {
  let pages = products.length / productsPerPage
  let pagination = []
  for (let i = 1; i < pages + 1; i++) {
    pagination.push(
      <PageLink onClick={() => setActivePage(i)} active={i == activePage}>
        {i}
      </PageLink>
    )
  }

  return pagination
}

const ProductsContainer = props => {
  const [categories, setCategories] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [pagedProducts, setPagedProducts] = useState([])

  useEffect(() => {
    let products = props.products
    let temporaryCategories = categories
    for (let i = 0; i < products.length; i++) {
      if (categories.indexOf(products[i].category) == -1) {
        temporaryCategories.push(products[i].category)
        setCategories(temporaryCategories)
      }
    }

    setPagedProducts(
      props.products.slice(
        (activePage - 1) * productsPerPage,
        productsPerPage * activePage
      )
    )
  }, [activePage, props.products])

  return (
    <StyledContainer>
      {pagedProducts
        ? pagedProducts.map((product, index) => (
            <Product product={product} key={index} />
          ))
        : null}
      <Pagination>
        <span>
          {(activePage - 1) * productsPerPage + 1} -{" "}
          {productsPerPage * activePage < props.products.length
            ? productsPerPage * activePage
            : props.products.length}{" "}
          of {props.products ? props.products.length : null} items
        </span>
        <div>{producePages(props.products, activePage, setActivePage)}</div>
      </Pagination>
    </StyledContainer>
  )
}

export default ProductsContainer
